import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, BACKEND_BASE } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { EVENT_TYPES } from "@/lib/format";

const DEFAULT = { team_name: "", team_logo: null, hidden_event_types: [], hide_categories: false, team_notes: "", tyre_targets: [{ brand: "Maxxis", model: "Gialla", target: 0.8, tolerance: 0.05 }] };
const SettingsContext = createContext({ settings: DEFAULT, visibleTypes: EVENT_TYPES, reload: () => {} });

export function SettingsProvider({ children }) {
  const { user } = useAuth();
  const [settings, setSettings] = useState(DEFAULT);
  const [loaded, setLoaded] = useState(false);

  const reload = useCallback(async () => {
    const { data } = await api.get("/settings");
    setSettings(data);
    setLoaded(true);
  }, []);

  useEffect(() => {
    if (user) {
      reload().catch(() => {});
    }
  }, [user, reload]);

  const visibleTypes = EVENT_TYPES.filter((ty) => !settings.hidden_event_types?.includes(ty));
  return (
    <SettingsContext.Provider value={{ settings, setSettings, reload, visibleTypes, loaded }}>{children}</SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);

export const fileUrl = (id) => `${BACKEND_BASE}/api/files/${id}`;
